import { render } from "./TextReaderMobile.vue?vue&type=template&id=5e096356&scoped=true"
import script from "./TextReaderMobile.vue?vue&type=script&lang=js"
export * from "./TextReaderMobile.vue?vue&type=script&lang=js"

import "./TextReaderMobile.vue?vue&type=style&index=0&id=5e096356&scoped=true&lang=scss"
import "./TextReaderMobile.vue?vue&type=style&index=1&id=5e096356&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e096356"]])

export default __exports__